export type Coordinates = {
  lat?: number;
  lng?: number;
};

export const defaultCoordinates: Coordinates = {
  lat: 37.5628,
  lng: 126.82679,
};

// export const defaultCoordinates: Coordinates = {
//   lat: 37.562794,
//   lng: 126.82642,
// };

export enum Reason {
  REPORT = "샌디 불편신고",
  BUILDING_CHANGE = "샌디 근무위치 설정"
}
